<div class="flex h-full w-full flex-col pb-4">
  <h2 class="py-4 text-center text-lg font-medium">Network Problem Areas</h2>
  <div
    class="flex min-h-0 flex-1 items-center justify-center"
    role="img"
    aria-label="Donut chart showing network problem areas by use case"
  >
    <apx-chart
      class="block h-full w-full"
      (chartReady)="onChartReady($event)"
      [series]="chartOptions().series"
      [chart]="chartOptions().chart"
      [labels]="chartOptions().labels"
      [title]="chartOptions().title"
      [legend]="chartOptions().legend"
      [colors]="chartOptions().colors"
      [plotOptions]="chartOptions().plotOptions"
      [dataLabels]="chartOptions().dataLabels"
    />
  </div>
</div>
